import { useLobbyFormatters } from "@lobby/utils-formatters";

import { Player } from "./player-model";

type Props = {
  withFormatter?: boolean;
};

export const usePlayerMoneyFormatter = ({ withFormatter = true }: Props = {}) => {
  const { data: player } = Player.usePlayer();
  const { formatMoney } = useLobbyFormatters();

  const currency = player?.currency ? player?.currency : undefined;

  if (!withFormatter) {
    //TODO refactor
    return (value: unknown, options: Intl.NumberFormatOptions = {}) =>
      formatMoney((value as number) * 100, { currency, ...options });
  }

  return (value: unknown, options: Intl.NumberFormatOptions = {}) =>
    formatMoney(value, { currency, ...options });
};
